import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-menu",
  templateUrl: "./med-icon-menu.component.html",
})
export class MedIconMenuComponent extends SvgMixinComponent {}
